import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../config/api";
import { FaArrowLeft, FaUser, FaPhone, FaMapMarkerAlt } from "react-icons/fa";

function OrderDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  const BASE_URL = `${API_BASE_URL}`;

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/orders/single/${id}`);
        // Console mein check karein: items[0].uniformId pura object hona chahiye
        console.log("Fetched Order Data:", res.data);
        setOrder(res.data);
      } catch (err) {
        console.error("Error fetching order:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchOrder();
  }, [id]);

 const getImageUrl = (item) => {
    // Sabse pehle console mein dekho item.uniformId hai ya nahi
    if (!item || !item.uniformId) {
        return "https://via.placeholder.com/60?text=No+Data";
    }

    const imagePath = item.uniformId.image;

    if (!imagePath) {
        return "https://via.placeholder.com/60?text=No+Img";
    }

    // Agar path full URL hai (Cloudinary/S3)
    if (imagePath.startsWith("http")) return imagePath;

    // Windows paths ke liye slash fix
    const cleanPath = imagePath.replace(/\\/g, "/");

    // Path cleanup (double 'uploads/' fix)
    const finalPath = cleanPath.startsWith("uploads/") ? cleanPath : `uploads/${cleanPath}`;

    return `${BASE_URL}/${finalPath}`;
};
  if (loading) return <div className="p-5 text-center">Loading Order...</div>;
  if (!order) return <div className="p-5 text-center">Order Not Found</div>;

  return (
    <div className="p-4" style={{ backgroundColor: "#f8fafc", minHeight: "100vh" }}>
      <button className="btn btn-sm btn-light border mb-3 shadow-sm" onClick={() => navigate(-1)}>
        <FaArrowLeft className="me-2" /> Back
      </button>

      <div className="row g-4">
        <div className="col-lg-8">
          <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
            <div className="p-4 border-bottom bg-white d-flex justify-content-between align-items-center">
              <div>
                <h5 className="fw-bold m-0">Order Items</h5>
                <small className="text-muted">ID: #{order._id?.slice(-6).toUpperCase()}</small>
              </div>
              <span className={`badge rounded-pill px-3 py-2 ${order.status === 'Shipped' ? 'bg-info' : 'bg-primary'}`}>
                {order.status || "Pending"}
              </span>
            </div>

            <div className="table-responsive">
              <table className="table align-middle mb-0">
                <thead className="bg-light text-uppercase small fw-bold">
                  <tr>
                    <th className="ps-4 py-3">Product</th>
                    <th className="py-3 text-center">Price</th>
                    <th className="py-3 text-center">Qty</th>
                    <th className="py-3 text-end pe-4">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {order.items?.map((item, i) => (
                    <tr key={i}>
                      <td className="ps-4 py-3">
                        <div className="d-flex align-items-center gap-3">
                          {/* ⭐ Image rendering with protection */}
                          <div style={{ width: "60px", height: "60px", backgroundColor: "#eee", borderRadius: "10px", overflow: "hidden" }}>
                            <img
                              src={getImageUrl(item)}
                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                              alt={item.name}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "https://via.placeholder.com/60?text=Error";
                              }}
                            />
                          </div>
                          <div>
                            <div className="fw-bold text-dark">{item.name}</div>
                            <small className="text-muted">{order.schoolName}</small>
                          </div>
                        </div>
                      </td>
                      <td className="text-center">₹{item.price}</td>
                      <td className="text-center">{item.quantity}</td>
                      <td className="text-end pe-4 fw-bold text-dark">₹{item.price * item.quantity}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="p-4 bg-white border-top text-end">
              <h4 className="fw-bold m-0" style={{ color: "#10b981" }}>Total: ₹{order.totalAmount}</h4>
            </div>
          </div>
        </div>

        <div className="col-lg-4">
          <div className="card border-0 shadow-sm rounded-4 p-4 mb-4">
            <h6 className="fw-bold mb-3"><FaUser className="me-2 text-success" /> Customer Info</h6>
            <p className="mb-0 fw-bold">{order.parentName || "Unknown Customer"}</p>
            {/* ⭐ Schema mein check karein agar address ke andar phone hai */}
            <p className="text-muted small"><FaPhone className="me-1" /> {order.address?.phone || order.phone || "N/A"}</p>
          </div>

          <div className="card border-0 shadow-sm rounded-4 p-4">
            <h6 className="fw-bold mb-3"><FaMapMarkerAlt className="me-2 text-danger" /> Address</h6>
            <div className="p-3 bg-light rounded-3">
              <p className="mb-1 small text-dark">{order.address?.addressLine || "No Address Provided"}</p>
              <p className="mb-0 small text-dark">
                {order.address?.city} {order.address?.pincode ? `- ${order.address.pincode}` : ""}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OrderDetails;